import React from "react";

const Data = () => {
    const getRandomGray = () => {
        const grayValue = Math.floor(Math.random() * 200) + 100;
        return `rgb(${grayValue}, ${grayValue}, ${grayValue})`;
    };

    return (
        <div className="third_section_container">
            <div className="third_section_cont">
                <h3 className="thirds_section_title">Cognitive data</h3>
                <p className="section_subtitle">
                    Erioon stores AI knowledge efficiently and retrieves only what matters, keeping context clean, preserving full memory access, and reducing costs.
                </p>
            </div>
            <div className="third_section_cont">
                <div className="cirle_main">
                    {Array.from({ length: 2500 }).map((_, index) => (
                        <div
                            className="smal_circles"
                            key={index}
                            style={{ backgroundColor: getRandomGray() }}
                        ></div>
                    ))}
                </div>

            </div>
        </div>
    )
}

export default Data